import Typography from "components/typography";
import { albumCover } from "constants/placeholderAlbumCover";
import React from "react";
import styled from "styled-components";

const TrackDetails = () => {
  return (
    <Container>
      <ThumbnailImage src={albumCover} alt="cover-image" />
      <Typography size="4rem" weight="bold" mb="1.6" m_size="lg" m_mb="0.4">
        Blueberry Faygo
      </Typography>
      <Typography size="2xl" weight="medium" m_size="s">
        Lil Mosey
      </Typography>
    </Container>
  );
};

export default TrackDetails;

const Container = styled.div`
  margin-bottom: 2.4rem;
  @media only screen and (max-width: 769px) {
    text-align: center;
    margin-bottom: 1.6rem;
    width: 100%;
  }
`;

const ThumbnailImage = styled.img`
  width: 68.4rem;
  height: 30.9rem;
  border-radius: 0.8rem;
  margin-bottom: 1.6rem;
  object-fit: cover;
  @media only screen and (max-width: 769px) {
    width: 100%;
    height: 20rem;
  }
`;
